
/**
 * url 마지막 path 추축
 * @param url: string ex) '/booking/subscription', 'booking/vehicle-option'
 * @returns subscription, vehicleOption 형태
 * */
export const getLastURLSegment = url => {
  const urlParts = url.split('/');
  const lastSegment = urlParts[urlParts.length - 1];

  return lastSegment
    .split('-')
    .map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}

/**
 * 선택된 item의 value로 target 추출
 * @param (targetDict: object, targetValue: string)
 * @returns string list 형태
 * */
export const getValueByTarget = (targetDict, targetValue, target) => {
  
  const selectedProduct = targetDict.find(product => product.value === targetValue);
  
  if (selectedProduct) {
    return selectedProduct[target];
  }
  return null;
}

export const VehiclesOptionCount = (value) => {
  if (value === 'threeVehicles') {
    return 3;
  }
  return 2;
}

/**
 * 사업자 등록번호를 xxx-xx-xxxxx 형식으로 포매팅
 * @param value: string (숫자)
 * @returns string 포매팅된 사업자 등록번호
 * */
export const formatBusinessRegistrationId = (value) => {
  // 숫자만 추출
  const digits = String(value).replace(/[^0-9]/g, '').slice(0, 10);

  // 파트별로 분리하고 빈 파트는 합치지 않음(끝에 불필요한 '-' 방지)
  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 5);
  const part3 = digits.slice(5);

  return [part1, part2, part3].filter(part => part && part.length > 0).join('-');
}

